import { defineMessages } from 'react-intl-next';

export const i18n: {
	opportunityStatusFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	opportunityStatusFilterLabel: {
		id: 'search-page.salesforce.filter.opportunityStatus',
		defaultMessage: 'Opportunity status',
		description: 'Label for filtering by Salesforce opportunity open/closed status',
	},
});
